import AnalyticsContainer from "../../../Component/Application/Analytics/analytics-container";

const AnalyticsPage = () => {
    return (
        <div className="page-body">
            <AnalyticsContainer/>
        </div>
    );
};

export default AnalyticsPage;